import { render, staticRenderFns } from "./PacientesAntecedentesAlergias.vue?vue&type=template&id=54123c1a&"
import script from "./PacientesAntecedentesAlergias.vue?vue&type=script&lang=js&"
export * from "./PacientesAntecedentesAlergias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports